export default __webpack_public_path__ + "static/media/ic_svc_rewards.64c35e15.png";